import React from 'react';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField.jsx';
import FormSelect from '../../../../../antd/form/FormSelect/FormSelect.jsx';
import FormDate from '../../../../../antd/form/FormDate/FormDate.jsx';
import FormRangeTimePicker from '../../../../../antd/form/FormRangeTimePicker/FormRangeTimePicker.jsx';
import { Col, Row } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { required } from '../../../../../antd/form/FormValidation.js';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import Form from '../../../../../antd/form/Form/Form.jsx';
import dayjs from 'dayjs';

const AttendanceEventForm = ({
  mode,
  teachers,
  rooms,
  scheduleBlocks,
  onChange,
  onSubmit,
  initials,
}) => {
  const { t } = useTranslation();

  if (mode === 'schedule') {
    return (
      <Form onFinish={onSubmit} initialValues={initials} key={initials.blockId}>
        <FormSelect
          label={t('Blok v rozvrhu')}
          name={'selectedBlock'}
          value={initials.selectedBlock}
          options={scheduleBlocks}
          placeholder={t('Vyberte blok z rozvrhu')}
          onChange={(value) => onChange(value)}
          rules={[required(t)]}
        />
        <FormTextField label={t('Názov')} name={'title'} disabled />
        <FormTextField label={t('Miestnosť')} name={'room'} disabled />
        <FormTextField label={t('Učiteľ')} name="created_by" disabled />
        <FormItem>
          <Row gutter={[10]}>
            <Col span={5}>
              <FormDate
                label={t('Dátum')}
                name={'date'}
                format="DD.MM.YYYY"
                style={{ width: '100%' }}
                disabledDate={(current) => {
                  // Disable future dates
                  if (current && current.isAfter(dayjs(), 'day')) {
                    return true;
                  }
                  // Allow only Mondays (dayjs().day(1) means Monday)
                  return current.day() !== initials.day;
                }}
                rules={[required(t)]}
                disabled={initials.blockId === undefined}
              />
            </Col>
            <Col span={5}>
              <FormRangeTimePicker
                label={t('Čas konania')}
                name={'time'}
                format="HH:mm"
                allowEmpty={[
                  initials.started_at === undefined,
                  initials.ended_at === undefined,
                ]}
                disabled
              />
            </Col>
          </Row>
        </FormItem>
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'attendanceEvents'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      </Form>
    );
  } else {
    return (
      <Form onFinish={onSubmit} initialValues={initials}>
        <FormTextField
          label={t('Názov udalosti')}
          name={'title'}
          rules={[required(t)]}
        />
        <FormSelect
          label={t('Miestnosť')}
          name={'room'}
          options={rooms}
          placeholder={t('Vyhľadať miestnosť')}
        />
        <FormTextField
          label={t('Učiteľ')}
          name="created_by"
          rules={[required(t)]}
          disabled
        />
        <FormSelect
          label={t('Zastupujúci')}
          name={'teacher_id'}
          options={teachers}
          placeholder={t('Vyhľadať učiteľa')}
        />
        <FormItem label={t('Dátum a čas')} rules={[required(t)]}>
          <Row gutter={[10]}>
            <Col span={5}>
              <FormDate
                name="date"
                label={t('Dátum')}
                rules={[required(t)]}
                style={{ width: '100%' }}
              />
            </Col>
            <Col span={5}>
              <FormRangeTimePicker
                label={t('Čas konania')}
                name="time"
                format="HH:mm"
                placeholder={['07:00', '20:00']}
                rules={[required(t)]}
                minuteStep={10} // Restrict minutes to 10-minute steps
                disabledTime={(date, type) => {
                  return {
                    disabledHours: () => {
                      const hours = [];
                      for (let i = 0; i < 7; i++) hours.push(i); // Disable before 07:00
                      for (let i = 21; i <= 23; i++) hours.push(i); // Disable after 20:00
                      return hours;
                    },
                  };
                }}
              />
            </Col>
          </Row>
        </FormItem>
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'attendanceEvents'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      </Form>
    );
  }
};

export default AttendanceEventForm;
